import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { companyEmailSettingsSchema } from '../schemas/company-email-settings.schema';

/**
 * Get a company's email settings
 * @returns Company Email Settings
 */
export function getCompanyEmailSettings(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(accountsEnvironment.resolve(this).companyEmailSettingsUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(companyEmailSettingsSchema));
}
